function setupCartDrop() {
    $('.cart-drop__toggle').click(function () {
        const $cartDropContent = $(this).next();
        $cartDropContent.slideToggle(250);
        $('.search-drop__content').slideUp(200);
    });

    $(document).click(function(){
        $('.cart-drop__content').slideUp(200);
    });
    $('#close-cart-drop').click(function(){
        $('.cart-drop__content').slideUp(200);
    });

    $('.cart-drop__content, .cart-drop').click(function(e){
        e.stopPropagation();
    });

    $('.remove-from-cart').click(removeFromCart);
}

function loadCart() {
    $('#cart-wrapper').load(
        url = '/cart/ .cart-drop',
        complete = setupCartDrop
    );
}

function addToCart() {
    const pk = $(this).data('pk');
    $.post(
        url='/cart/',
        data={'occasion': pk},
        function(data) {
            $('#cart-wrapper').html(data);
            setupCartDrop();
            $('.cart-drop__content.visible').slideDown(250);
        }
    );
}

function removeFromCart() {
    const pk = $(this).data('pk');
    $.post(
        url='/cart/',
        data={'row': pk},
        function(data) {
            $('#cart-wrapper').html(data);
            setupCartDrop();
            $('.cart-drop__content.visible').show();
        }
    );
}

$(document).ready(function () {
    loadCart();
    $('.add-to-cart').click(addToCart);
});
